import { formatMoney } from '../../lib/formatters.ts'
import type { CollectionItem, MoneyFig } from '../../api/cashReport'

function collectionWhen(item: CollectionItem): string {
  const predicted = item.display || item.likely_label
    || (item.predicted_paid_at ? `Likely ${item.predicted_paid_at}` : '')
  if (!predicted) return 'Date unknown · no payment history yet'
  const bits = [predicted]
  if (item.contract_due) bits.push(`contract ${item.contract_due}`)
  if (item.status) bits.push(item.status)
  bits.push('Open source')
  return bits.join(' · ')
}

type Props = {
  items: CollectionItem[]
  total?: MoneyFig | null
  thisWeekStart?: string | null
  onOpenProject: (projectId: number, focus?: string) => void
}

export default function CollectionsList({ items, total, thisWeekStart, onOpenProject }: Props) {
  const weekItems = thisWeekStart
    ? items.filter((i) => i.week_start === thisWeekStart)
    : []
  const weekCents = weekItems.reduce((s, i) => s + (Number(i.amount_cents) || 0), 0)
  return (
    <section className="cr-panel" data-testid="cr-collections">
      <header className="cr-info-head">
        <div className="cr-eyebrow">Money coming</div>
        <h3><span className="cr-money">{total?.formatted || formatMoney((total?.amount ?? 0))}</span> in 30 days</h3>
        {weekItems.length ? (
          <p data-testid="cr-collections-this-week">
            This week · {weekItems.length} pay app{weekItems.length === 1 ? '' : 's'} · {formatMoney(weekCents / 100)}
          </p>
        ) : (
          <p>Likely dates use predicted timing. Contract due is shown second.</p>
        )}
      </header>
      {items.map((item) => (
        <div key={item.pay_app_id} className="cr-source-row" data-testid={`cr-collection-${item.pay_app_id}`}>
          <div className="cr-source-main">
            <button
              type="button"
              onClick={() => item.project_id != null && onOpenProject(item.project_id, item.focus)}
            >
              {item.project_name || 'Project'} · Pay app {item.pay_app_id}
            </button>
            <span>
              {collectionWhen(item)}
            </span>
          </div>
          <button
            type="button"
            className="cr-source-amount"
            onClick={() => item.project_id != null && onOpenProject(item.project_id, item.focus)}
          >
            {item.amount?.formatted || formatMoney((item.amount_cents || 0) / 100)}
          </button>
        </div>
      ))}
    </section>
  )
}
